import logo from "../assets/logo.svg";
import arrowDown from "../assets/arrow_dowm.png";
import en from "../assets/en.png";
import it from "../assets/it.png";
import header_home from "../assets/header-home-1200x600.png";
import iso_9001_certificate_white_en_US from "../assets/iso-9001-certificate-white-en_US.svg";
import iso_9001_certificate_white_it_IT from "../assets/iso-9001-certificate-white-it_IT.svg";
import assembly from "../assets/img_assemblie_small.png";
import broaching from "../assets/img_broaching_small.png";
import milling from "../assets/img_milling_small.png";
import ripresa from "../assets/img_ripresa_small.png";
import thread from "../assets/img_thread_small.png";
import turning from "../assets/img_turning_small.png";
import experienceIMG from "../assets/experienceIMG.png";
import inquiryIMG from "../assets/inquiryIMG.svg";
import quotationIMG from "../assets/quotationIMG.svg";
import orderIMG from "../assets/orderIMG.svg";
import productionIMG from "../assets/productionIMG.svg";
import shipmentIMG from "../assets/transportIMG.svg";
import experienceBG from "../assets/experienceBG.png";
import contactBG from "../assets/contactBG.png";
import headerSideBG from "../assets/header_sidepages.svg";
import logo_dnv from "../assets/DNV_GL_logo.png";
import logo_accredia from "../assets/logo_accredia.png";
import industry_40 from "../assets/industry_40.png";
import steel_bars from "../assets/steel_bars.png";
import aluminum_bars from "../assets/alluminum_bars.png";
import brass_bars from "../assets/brass_bars.png";
import copper_bars from "../assets/copper_bars.png";
import plastic_bars from "../assets/plastic_bars.png";
import pannels_image_one from "../assets/pannel_image_one.jpeg"
import pannels_image_two from "../assets/pannel_image_two.jpeg"
import pannel_video from "../assets/pannel_video.mp4"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  pannel_video,
  pannels_image_one,
  pannels_image_two,
  logo,
  arrowDown,
  en,
  it,
  header_home,
  iso_9001_certificate_white_en_US,
  iso_9001_certificate_white_it_IT,
  assembly,
  broaching,
  milling,
  ripresa,
  thread,
  turning,
  experienceIMG,
  inquiryIMG,
  quotationIMG,
  orderIMG,
  productionIMG,
  shipmentIMG,
  experienceBG,
  contactBG,
  headerSideBG,
  logo_dnv,
  logo_accredia,
  industry_40,
  steel_bars,
  aluminum_bars,
  brass_bars,
  copper_bars,
  plastic_bars,
};
